module.exports = __webpack_public_path__ + "media/country_flags/nz-bbd52e81.png";